export const FormField = {
  controlledBy: 'controlledBy',
  peo: 'peo',
  peoPayrollProvider: 'peoPayrollProvider',
  keepOwnRevenueShare: 'keepOwnRevenueShare',
} as const;
